
import './App.css';
import DisplayListOfPeople from "./components/DisplayListOfPeople";

function App() {
  return (
    <div className="App">
      <DisplayListOfPeople />
    </div>
  );
}

export default App;
